/* A1CW predictive (type-ahead) search — V20.
   Attaches a suggestions dropdown to every form[data-header-search]
   (desktop header + mobile search row share the same form markup).
   Uses Shopify's /search/suggest.json predictive endpoint. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var BASE = ROOT.replace(/\/$/, '');
  var ENDPOINT = BASE + '/search/suggest.json';
  var MIN_CHARS = 2;

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(form) {
    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;

    form.classList.add('has-predictive');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    var panel = document.createElement('div');
    panel.className = 'predictive';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);

    var controller = null;
    var activeIndex = -1;
    var items = [];

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
      items = [];
    }

    function open() {
      if (panel.innerHTML.trim() === '') return;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(i) {
      items.forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
        if (idx === i) el.setAttribute('aria-selected', 'true');
        else el.removeAttribute('aria-selected');
      });
      activeIndex = i;
      if (items[i]) items[i].scrollIntoView({ block: 'nearest' });
    }

    function viewAllHref(term) {
      var action = form.getAttribute('action') || (BASE + '/search');
      return action + '?q=' + encodeURIComponent(term);
    }

    function render(data, term) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [];
      var collections = r.collections || [];
      var pages = r.pages || [];
      var html = '';

      if (products.length) {
        html += '<div class="predictive__group"><div class="predictive__heading">Products</div>';
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var brand = p.vendor ? '<span class="predictive__brand">' + esc(p.vendor) + '</span>' : '';
          html += '<a class="predictive__item predictive__item--product" role="option" href="' + esc(p.url) + '">' +
            '<span class="predictive__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span>' +
            '<span class="predictive__text">' + brand + '<span class="predictive__title">' + esc(p.title) + '</span></span>' +
            '</a>';
        });
        html += '</div>';
      }

      var links = collections.concat(pages);
      if (links.length) {
        html += '<div class="predictive__group"><div class="predictive__heading">Pages &amp; collections</div>';
        links.forEach(function (l) {
          html += '<a class="predictive__item predictive__item--link" role="option" href="' + esc(l.url) + '">' +
            '<span class="predictive__title">' + esc(l.title) + '</span></a>';
        });
        html += '</div>';
      }

      if (products.length || links.length) {
        html += '<a class="predictive__item predictive__viewall" role="option" href="' + esc(viewAllHref(term)) + '">' +
          'See all results for &ldquo;' + esc(term) + '&rdquo;</a>';
      } else {
        html = '<div class="predictive__empty">No matches yet.</div>' +
          '<a class="predictive__item predictive__viewall" role="option" href="' + esc(viewAllHref(term)) + '">' +
          'Search all for &ldquo;' + esc(term) + '&rdquo;</a>';
      }

      panel.innerHTML = html;
      items = Array.prototype.slice.call(panel.querySelectorAll('.predictive__item'));
      activeIndex = -1;
      open();
    }

    var run = debounce(function () {
      var term = input.value.trim();
      if (term.length < MIN_CHARS) { close(); return; }
      if (controller) { try { controller.abort(); } catch (e) {} }
      controller = (window.AbortController) ? new AbortController() : null;
      var url = ENDPOINT + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) { return res.json(); })
        .then(function (data) { render(data, term); })
        .catch(function (err) { if (!err || err.name !== 'AbortError') close(); });
    }, 200);

    input.addEventListener('input', run);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && panel.innerHTML.trim() !== '') open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(activeIndex + 1, items.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(activeIndex - 1, 0)); }
      else if (e.key === 'Enter') {
        if (activeIndex >= 0 && items[activeIndex]) { e.preventDefault(); window.location.href = items[activeIndex].getAttribute('href'); }
      } else if (e.key === 'Escape') { close(); }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function boot() {
    var forms = document.querySelectorAll('form[data-header-search]');
    Array.prototype.forEach.call(forms, init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
